import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {HistoryElement} from '@/models/HistoryElement';
import {FpMessageType} from '@/modules/deals/enums/FpMessageType';
import {isEqual, chain} from 'lodash-es';
import FpMessage from '@/components/messages/FpMessage.vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {BaseFilter} from '@/models/Filter';
import { useInstance } from '@/composables/useInstance';
import { TimelineDictionary, TimelineConfig} from '@/commons/dictionaries/TimelineDictionary';
type FilterPagination = Pick<BaseFilter, 'page' | 'totalPagesNumber'>;

interface Props {
  showNewNoteOption?: boolean;
  chat?: boolean;
  notesOnly?: boolean;
  last?: number;
  historyElements: HistoryElement<any>[];
  dealId?: number;
  loanApplicationId?: number;
  isSidebar?: boolean;
  filterOptions?: FilterPagination;
  loadMoreButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryElements',
  props: {
    showNewNoteOption: { type: Boolean, default: true },
    chat: { type: Boolean, default: false },
    notesOnly: { type: Boolean, default: false },
    last: { default: 0 },
    historyElements: { default: () => [] },
    dealId: null,
    loanApplicationId: null,
    isSidebar: { type: Boolean, default: false },
    filterOptions: null,
    loadMoreButton: { type: Boolean, default: false }
  },
  emits: ["click:new-note", "fetchHistoryElements"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click:new-note', newNote: string, dealId: number | undefined): void,
  (e: 'fetchHistoryElements'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { showNewNoteOption: boolean, chat: boolean, notesOnly: boolean, last: number, historyElements: HistoryElement<any>[], dealId?: number, loanApplicationId?: number, isSidebar: boolean, filterOptions?: FilterPagination, loadMoreButton: boolean };

const {$snackbarService,} = useInstance();





const newNote = ref<string>('');
//@Warning   <template v-if="historyElement.createdDate"> stąd date.createdDate!

const isTimelineMatch = (
  historyElement: HistoryElement<any>,
  config: TimelineConfig
): boolean => {
  let elements = props.historyElements;
  
  if (config.filterPrevious) {
    elements = elements.filter(el => config.filterPrevious!(el.createdDate!));
  }
  
  return isEqual(
    historyElement,
    elements.find(date => config.check(date.createdDate!))
  );
};

const historyList = computed<HistoryElement<any>[]>(() => {
  let list: HistoryElement<any>[] = props.historyElements;
  if (props.last) {
    list = list.slice(0, props.last);
  }

  if (!props.chat) {
    return list;
  }

  return chain<HistoryElement<any>>(list)
    .filter(historyElement => historyElement.type === FpMessageType.NOTE_ADDED)
    .uniq()
    .value();
});

function addNote(): void {
  if (newNote.value.length) {
    emit('click:new-note', newNote.value, props.dealId ? props.dealId : props.loanApplicationId);
    newNote.value = '';
  } else {
    $snackbarService.openWarningSnackbar(I18NGetter().useHistoryElements.WARNING_SNACKBAR_ADD_NOTE);
  }
}

return { __sfc: true,$snackbarService, props, emit, newNote, isTimelineMatch, historyList, addNote, FpMessage, I18NGetter, TimelineDictionary }
}

})